import { Auth0Provider } from "@auth0/auth0-react";
import AuthLogin from "./AuthLogin";
import { useNavigate } from "react-router";

const Auth0ProviderWithHistory = ({ domain, clientId, children }) => {
	const navigate = useNavigate();
	const onRedirectCallback = (appState) => {
		const url =
			appState?.returnTo ||
			localStorage.getItem("returnTo") ||
			window.location;
		const urlObj = new URL(url);
		navigate(urlObj.pathname + urlObj.search + urlObj.hash);
		localStorage.removeItem("returnTo");
	};

	return (
		<Auth0Provider
			domain={domain}
			clientId={clientId}
			onRedirectCallback={onRedirectCallback}
			authorizationParams={{
				redirect_uri: window.location.origin,
			}}
			cacheLocation="memory"
		>
			<AuthLogin>{children}</AuthLogin>
		</Auth0Provider>
	);
};

export default Auth0ProviderWithHistory;
